// @ts-nocheck
/* eslint-disable */
export const appQueued24Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="2.3999" width="6.4" height="19.2" rx="1.6" fill="currentColor"/><rect x="13.6001" y="2.3999" width="6.4" height="19.2" rx="1.6" fill="currentColor"/></svg>`,
    name: 'queued-24' as const
};